import { Typography, Divider, Row, Col, Statistic } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell, CartesianGrid } from 'recharts';


const { Title, Text } = Typography;


export default function LottoFullStateStats(props) {
    const { data, type, color, amount, icon } = props;
    const statesObj = JSON.parse(data);
    const chartData = Object.entries(statesObj).map(([key, value]) => ({
        estado: key.replace(/_/g, ' '),
        ventas: value,
    }));


    return (
        <>
            <div style={{ marginBottom: '24px', textAlign: 'center' }}>
                <Row gutter={[16, 16]}>
                    <Col xs={12} sm={12}>
                        <Title level={4} style={{ margin: 0, color: color }}>
                            <GlobalOutlined /> Distribución por Estados
                        </Title>
                        <Text type="secondary">Listado completo de {type.toLowerCase()} por estado</Text>
                    </Col>
                    <Col xs={12} sm={12}>
                        <Statistic
                            title={type}
                            value={amount}
                            prefix={icon}
                            valueStyle={{ color: color, fontWeight: 'bold' }}
                        />
                    </Col>
                </Row>
            </div>

            <Divider style={{ margin: '12px 0' }} />

            <div style={{
                width: '100%',
                height: '500px',
                overflowY: 'auto',
                paddingRight: '10px',
                scrollbarWidth: 'thin'
            }}>
                <div style={{ width: '100%', height: chartData.length * 40 }}>
                    <ResponsiveContainer>
                        <BarChart
                            layout="vertical"
                            data={chartData}
                            margin={{ top: 5, right: 30, left: 40, bottom: 5 }}
                        >
                            <CartesianGrid strokeDasharray="3 3" horizontal={false} stroke="#e0e0e0" />
                            <XAxis type="number" hide />
                            <YAxis
                                dataKey="estado"
                                type="category"
                                width={140}
                                axisLine={false}
                                tickLine={false}
                                style={{ fontSize: '11px', fontWeight: '500', fill: '#595959' }}
                            />
                            <Tooltip
                                cursor={{ fill: 'rgba(212, 175, 55, 0.05)' }}
                                contentStyle={{ borderRadius: '8px', border: `1px solid gray`, background: '#fff' }}
                            />
                            <Bar
                                dataKey="ventas"
                                barSize={20}
                                radius={[0, 4, 4, 0]}
                            >
                                {chartData.map((entry, index) => (
                                    <Cell
                                        key={`cell-${index}`}
                                        fill={entry.ventas > 0 ? color : color}
                                    />
                                ))}
                            </Bar>
                        </BarChart>
                    </ResponsiveContainer>
                </div>
            </div>

            <div style={{ marginTop: '20px', fontSize: '12px', textAlign: 'right', color: '#8c8c8c' }}>
                Total de zonas analizadas: {chartData.length}
            </div>
        </>
    );
};